/*import Modal from "bootstrap/js/dist/modal";
import Tab from "bootstrap/js/dist/tab";
import Collapse from "bootstrap/js/dist/collapse";
import Offcanvas from "bootstrap/js/dist/offcanvas";*/
import {Modal, Tab, Collapse, Offcanvas} from "bootstrap";
import Alpine from 'alpinejs'
import Swiper from 'swiper';
import {A11y, Controller, FreeMode, Navigation, Pagination} from 'swiper/modules';
import scrollHandler from "./scrollHandler";
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {register} from 'swiper/element/bundle';
import 'swiper/css';
import intersect from '@alpinejs/intersect'
import {tabsCarousel} from "./alpine/tabsCarousel.js";
import {loadModuleIfExists} from "./helpers.js";
import './scrollToHash.js';
import Lenis from 'lenis';

register();

Alpine.plugin(intersect)
Alpine.data('tabsCarousel', tabsCarousel);
Alpine.start()

gsap.registerPlugin(ScrollTrigger, SplitText);
window.gsap = gsap;
window.SplitText = SplitText;

//funzione per lettura parametri get
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

document.addEventListener('DOMContentLoaded', async () => {
    scrollHandler();

    /**
     * Set 1dvh
     */
    const dvh = window.innerHeight / 100;
    document.documentElement.style.setProperty('--dvh', `${dvh}px`);

// Offcanvas menu header fade effect
    const menuOffcanvas = document.getElementById('offcanvasMenu');
    menuOffcanvas.classList.add('fade-transition');
    menuOffcanvas.addEventListener('hide.bs.offcanvas', function (event) {
        menuOffcanvas.style.opacity = '0';
        menuOffcanvas.querySelectorAll('.overlay-submenu.active').forEach(submenu => {
            submenu.classList.remove('active');
        });

        menuOffcanvas.querySelectorAll('.overlay-active').forEach(el => {
            el.classList.remove('overlay-active');
        });

        const navbarNav = menuOffcanvas.querySelector('.navbar-nav');
        if (navbarNav) {
            navbarNav.classList.remove('overlay-active');
        }

        menuOffcanvas.querySelectorAll('.collapse.show, .collapse.collapsing').forEach(collapseEl => {
            collapseEl.classList.remove('show', 'collapsing');
            collapseEl.style.height = '';
        });

        menuOffcanvas.querySelectorAll('[data-bs-toggle="collapse"][aria-expanded="true"]').forEach(trigger => {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.classList.add('collapsed');
        });
    });

    menuOffcanvas.addEventListener('show.bs.offcanvas', function () {
        menuOffcanvas.style.opacity = '1';
    });

    document.querySelectorAll('.dropdown-toggle').forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            const parent = this.parentElement;

            document.querySelectorAll('.menu-item-has-children.show').forEach(openItem => {
                if (openItem !== parent) openItem.classList.remove('show');
            });

            parent.classList.toggle('show');
        });
    });

    // Menu: overlay items
    const overlayItems = document.querySelectorAll(".overlay");
    const navbarNav = document.querySelector(".navbar-nav");

    overlayItems.forEach((overlayItem) => {
        const navLink = overlayItem.querySelector("a");
        const overlaySubmenu = overlayItem.querySelector(".overlay-submenu");
        const backLink = overlaySubmenu.querySelector(".back-link");

        navLink.addEventListener("click", (e) => {
            e.preventDefault();

            document.querySelectorAll(".overlay-submenu.active").forEach((submenu) => {
                if (submenu !== overlaySubmenu) {
                    submenu.classList.remove("active");
                    submenu.parentElement.classList.remove("overlay-active");
                }
            });
            overlayItem.classList.add("overlay-active");
            overlaySubmenu.classList.add("active");
            navbarNav.classList.add("overlay-active");
        });

        backLink.addEventListener("click", (e) => {
            e.preventDefault();
            overlayItem.classList.remove("overlay-active");
            overlaySubmenu.classList.remove("active");
            navbarNav.classList.remove("overlay-active");
        });
    });


    //Menu: cambio img all'hover su voci menu
    const menuLinks = document.querySelectorAll('.navbar-nav [data-image]');
    const imageWrapper = document.querySelector('.image-wrapper');

    if (imageWrapper) {
        menuLinks.forEach(link => {
            const imageUrl = link.getAttribute('data-image');
            if (imageUrl) {
                const img = new Image();
                img.src = imageUrl;
            }
        });

        menuLinks.forEach(link => {
            link.addEventListener('mouseenter', function () {
                const imageUrl = this.getAttribute('data-image');
                if (imageUrl) {
                    imageWrapper.style.backgroundImage = `url('${imageUrl}')`;
                }
            });

            link.addEventListener('mouseleave', function () {
                imageWrapper.style.backgroundImage = '';
            });
        });
    }


    // Blocchi Lista link e Accordion con img che cambiano all'hover
    const linkListLinks = document.querySelectorAll(
        '#link-list-figure ~ * [data-image], .link-list [data-image], #accordionInfo .accordion-button[data-image]'
    );
    const linkListImage = document.getElementById('link-list-image');

    if (linkListImage) {
        linkListLinks.forEach(link => {
            const imageUrl = link.getAttribute('data-image');
            if (imageUrl) {
                const img = new Image();
                img.src = imageUrl;
            }
        });

        const defaultSrc = linkListImage.src;

        linkListLinks.forEach(link => {
            link.addEventListener('mouseenter', function () {
                const imageUrl = this.getAttribute('data-image');
                if (imageUrl) {
                    linkListImage.src = imageUrl;
                }
            });

            link.addEventListener('mouseleave', function () {
                linkListImage.src = defaultSrc;
            });
        });
    }


    // Text With Select
    const backdrop = document.getElementById('backdrop');
    const modal = document.getElementById('inline-modal');
    const optionsList = document.getElementById('options-list');

    var nascondi_evento = findGetParameter('noe');
    if(nascondi_evento) {
        document.getElementById("text-with-select").classList.add('d-none');
        document.getElementById("form-contatti-p2").setAttribute('style', '');
    }

    if (backdrop && modal && optionsList) {
        let activeSelectable = null;

        document.querySelectorAll('.selectable').forEach(el => {
            el.setAttribute('aria-label', `${el.dataset.label}: ${el.textContent.trim()}`);
        });

        function openModal(selectable) {
            activeSelectable?.classList.remove('active');
            activeSelectable = selectable;
            selectable.classList.add('active');

            const current = selectable.textContent.trim();
            const opts = textWithSelectOptions[selectable.dataset.field] ?? [];

            //optionsList.innerHTML = opts.map(o =>
            optionsList.innerHTML = Object.entries(opts).map(([key, label]) =>
                `<li class="h3 px-7 list-group-item${label === current ? ' active' : ''} find-li-item-${key}" 
                    data-value="${key}" 
                    tabindex="0" 
                    role="option">${label}</li>`
            ).join('');

            modal.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;display:block;';
            const {offsetWidth: mW, offsetHeight: mH} = modal;
            modal.style.cssText = '';

            const {left: rL, top: rT, width: rW, height: rH} = selectable.getBoundingClientRect();
            const left = Math.max(8, Math.min(rL + rW / 2 - mW / 2, window.innerWidth - mW - 8));
            const top = Math.max(8, Math.min(rT + rH / 2 - mH / 2, window.innerHeight - mH - 8));

            modal.style.left = `${left}px`;
            modal.style.top = `${top}px`;

            backdrop.classList.add('visible');
            setTimeout(() => {
                modal.classList.add('open');
                optionsList.querySelector('li')?.focus();
            });
        }

        function closeModal() {
            setTimeout(() => {
                modal.classList.remove('open');
            }, 50);
            backdrop.classList.remove('visible');
            activeSelectable?.classList.remove('active');
            activeSelectable?.focus();
            activeSelectable = null;
        }

        optionsList.addEventListener('click', e => {
            const li = e.target.closest('li[data-value]');
            if (!li || !activeSelectable) {
                closeModal()
                return;
            }
            activeSelectable.textContent = li.textContent.trim();
            activeSelectable.setAttribute('aria-label', `${activeSelectable.dataset.label}: ${li.textContent.trim()}`);

            //imposto il valore nelle select e negli input nascosti
            document.getElementById(activeSelectable.dataset.field).value = li.dataset.value;
            const field = document.getElementById(activeSelectable.dataset.field + "Real");
            if(field) {
                const option = field.querySelector(`option[value="${li.dataset.value}"]`);
                if (option) {
                    option.selected = true;
                }
            }

            closeModal();
        });

        function check_dispo(addToClass) {
            var sedeScelta = document.getElementById("selectLocation" + addToClass).value;
            var eventoScelto = document.getElementById("selectEvent" + addToClass).value;
            var servizioScelto = document.getElementById("selectServizio" + addToClass).value;

            //se non ho ancora scelto nessuna sede, oppure la sede ma niente altro, non stampo nulla quindi ok
            if(sedeScelta == "" || (eventoScelto == "" && servizioScelto == "")) {
                return true;
            }

            var okEvento = (eventoScelto == "") || (typeof textWithSelectEventConstraints[sedeScelta][eventoScelto] != "undefined" && textWithSelectEventConstraints[sedeScelta][eventoScelto] === 1);
            var okServizio = (servizioScelto == "") || (typeof textWithSelectServiceConstraints[sedeScelta][servizioScelto] != "undefined" && textWithSelectServiceConstraints[sedeScelta][servizioScelto] === 1);

            return okEvento && okServizio;
        }

        document.body.addEventListener('click', (e) => {
            if (e.target.closest('#options-list .list-group-item')) {
                //controllo se non sono state fatte scelte non consentite
                if(check_dispo("")) {
                    document.getElementById("avviso_incompatibile").classList.add('d-none');
                    document.getElementById("avvisoCombo").value = "";
                } else {
                    document.getElementById("avviso_incompatibile").classList.remove('d-none');
                    document.getElementById("avvisoCombo").value = "ATTENZIONE: l'utente ha selezionato una combinazione di sede e servizi non disponibile";
                }
            }
        });

        document.getElementById("button-text-with-select").addEventListener('click', e => {
            document.getElementById("form-text-with-select").submit();
        })

        document.querySelectorAll('.selectable').forEach(selectable => {
            selectable.addEventListener('click', e => {
                e.stopPropagation();
                activeSelectable === selectable ? closeModal() : openModal(selectable);
            });
        });

        backdrop.addEventListener('click', closeModal);
        document.addEventListener('keydown', e => e.key === 'Escape' && closeModal());

        optionsList.addEventListener('keydown', e => {
            const items = [...optionsList.querySelectorAll('li')];
            const i = items.indexOf(document.activeElement);
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                items[i + 1]?.focus();
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                items[i - 1]?.focus();
            }
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                document.activeElement.click();
            }
            if (e.key === 'Tab') {
                e.preventDefault();
                if (e.shiftKey) {
                    (items[i - 1] ?? items[items.length - 1])?.focus();
                } else {
                    (items[i + 1] ?? items[0])?.focus();
                }
            }
        });

        //se ho in get i parametri di popolamento form contatti eventi, vado a simulare i click
        var tipo_evento = findGetParameter('tp');
        if (tipo_evento) {
            //sistemo la select finta solo visualizzazione
            activeSelectable = document.getElementById("buttonEventType");
            openModal(activeSelectable);
            var li = document.querySelector(`.find-li-item-${tipo_evento}`);
            if (li) {
                li.click();
            }
        }
        var extra_evento = findGetParameter('ex');
        if (extra_evento) {
            //sistemo la select finta solo visualizzazione
            activeSelectable = document.getElementById("buttonEventExtra");
            openModal(activeSelectable);
            var li = document.querySelector(`.find-li-item-${extra_evento}`);
            if (li) {
                li.click();
            }
        }
        var persone_evento = findGetParameter('np');
        if (persone_evento) {
            //sistemo la select finta solo visualizzazione
            activeSelectable = document.getElementById("buttonEventPeople");
            openModal(activeSelectable);
            var li = document.querySelector(`.find-li-item-${persone_evento}`);
            if (li) {
                li.click();
            }
        }
        var sede_evento = findGetParameter('sd');
        if (sede_evento) {
            //sistemo la select finta solo visualizzazione
            activeSelectable = document.getElementById("buttonEventLocation");
            openModal(activeSelectable);
            var li = document.querySelector(`.find-li-item-${sede_evento}`);
            if (li) {
                li.click();
            }
        }
    }


    // Hero Slider Servizi
    const leftSlides = document.querySelectorAll('[data-slider-col="left"] .hero-servizi__slide');
    const rightSlides = document.querySelectorAll('[data-slider-col="right"] .hero-servizi__slide');

    if (leftSlides.length && rightSlides.length) {

        let currentIndex = 0;
        const totalSlides = leftSlides.length;
        const autoplaySpeed = 5000;

        function updateSlider() {
            let prevIndex = currentIndex;
            currentIndex = (currentIndex + 1) % totalSlides;
            let nextIndex = (currentIndex + 1) % totalSlides;

            const updateColumnClasses = (slides) => {
                slides.forEach(slide => {
                    slide.classList.remove('active', 'prev', 'next');
                });
                slides[prevIndex].classList.add('prev');
                slides[currentIndex].classList.add('active');
                slides[nextIndex].classList.add('next');
            };

            updateColumnClasses(leftSlides);
            updateColumnClasses(rightSlides);
        }

        function init() {
            leftSlides[0].classList.add('active');
            rightSlides[0].classList.add('active');

            if (totalSlides > 1) {
                leftSlides[1].classList.add('next');
                rightSlides[1].classList.add('next');
            }

            setInterval(updateSlider, autoplaySpeed);
        }

        init();
    }


    // Carousel with lightbox
    document.querySelectorAll('.lightbox-carousel').forEach(carouselEl => {
        const swiperInstance = new Swiper(carouselEl, {
            modules: [Pagination, FreeMode],
            slidesPerView: 'auto',
            spaceBetween: 16,
            freeMode: true,
            pagination: {
                el: carouselEl.querySelector('.swiper-pagination'),
                clickable: true,
                dynamicBullets: true,
            },
            breakpoints: {
                768: {spaceBetween: 80}
            },
            on: {
                init: function () {
                    const galleryContainer = carouselEl.querySelector('.swiper-wrapper');
                    if (galleryContainer) {
                        lightGallery(galleryContainer, {
                            licenseKey: 'C76B2185-9DD1-4479-87D1-8CCF322D3D43',
                            selector: 'a',
                            speed: 1200,
                            download: false,
                            plugins: [lgZoom, lgFullscreen, lgThumbnail],
                            thumbnail: true,
                            animateThumb: true,
                            toggleThumb: true,
                            zoom: true,
                            actualSize: false,
                            showZoomInOutIcons: true,
                        });
                    }
                }
            }
        });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    carouselEl.classList.add('is-animated');
                    const isMobile = window.innerWidth < 768;
                    swiperInstance.params.spaceBetween = isMobile ? 16 : 32;
                    swiperInstance.update();
                    observer.unobserve(carouselEl);
                }
            });
        }, {threshold: 0.3});

        observer.observe(carouselEl);
    });


// Cambio bg all'entrata in viewport
    function createFadeObserver(selector) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.3 });

        document.querySelectorAll(selector).forEach(el => observer.observe(el));
    }

    createFadeObserver('.fade-bg');
    createFadeObserver('.fade-bg-inverse');


    // Mosaic Gallery (Gallery con video in Scheda location e Schede servizi)
    const mosaicGalleries = document.querySelectorAll('.mosaic-gallery');

    mosaicGalleries.forEach(galleryContainer => {
        const btnSeeAll = galleryContainer.querySelector('.mosaic-gallery__see-all');
        const imagesData = galleryContainer.dataset.mosaicImages;
        let dynamicimgEl = [];

        if (imagesData) {
            try {
                dynamicimgEl = JSON.parse(imagesData);
            } catch (error) {
            }
        }

        if (btnSeeAll && dynamicimgEl.length > 0) {
            const dynamicimgGallery = lightGallery(btnSeeAll, {
                licenseKey: 'C76B2185-9DD1-4479-87D1-8CCF322D3D43',
                dynamic: true,
                plugins: [lgVideo, lgZoom, lgFullscreen, lgThumbnail],
                hash: false,
                rotate: false,
                dynamicEl: dynamicimgEl,
                thumbnail: true,
                animateThumb: true,
                toggleThumb: true,
                zoom: true,
                actualSize: false,
                showZoomInOutIcons: true,
            });

            btnSeeAll.addEventListener('click', () => dynamicimgGallery.openGallery(0));

            const galleryItems = galleryContainer.querySelectorAll('.gallery-item');

            galleryItems.forEach((item, index) => {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    dynamicimgGallery.openGallery(index);
                });
            });
        }
    });


    // VERTICAL SLIDER (in Scheda Punto Ristoro)

    // per calcolare l'altezza dinamica
    function setElasticVerticalHeight(swiperInstance) {
        let maxHeight = 0;

        swiperInstance.slides.forEach(slide => {
            const content = slide.firstElementChild;
            if (content) {
                const height = content.offsetHeight;
                if (height > maxHeight) maxHeight = height;
            }
        });

        const currentHeight = parseInt(swiperInstance.el.style.height, 10) || 0;

        if (maxHeight > 0 && maxHeight !== currentHeight) {
            swiperInstance.el.style.height = `${maxHeight}px`;
            swiperInstance.update();
        }
    }

    const verticalSliderNode = document.querySelector('.v-slider');

    if (verticalSliderNode) {
        const swiperTitle = new Swiper(verticalSliderNode.querySelector('.v-slider-title'), {
            modules: [Controller],
            direction: 'vertical',
            speed: 1200,
            allowTouchMove: false,
            on: {
                init: function () {
                    setElasticVerticalHeight(this);
                },
                resize: function () {
                    setElasticVerticalHeight(this);
                }
            }
        });

        const swiperNum = new Swiper(verticalSliderNode.querySelector('.v-slider-num'), {
            modules: [Controller],
            direction: 'vertical',
            speed: 1200,
            allowTouchMove: false,
            observer: true,
            observeParents: true,
            on: {
                init: function () {
                    setElasticVerticalHeight(this);
                },
                resize: function () {
                    setElasticVerticalHeight(this);
                }
            }
        });

        const swiperTxt = new Swiper(verticalSliderNode.querySelector('.v-slider-txt'), {
            modules: [Controller],
            direction: 'vertical',
            speed: 1200,
            allowTouchMove: false,
            on: {
                init: function () {
                    setElasticVerticalHeight(this);
                },
                resize: function () {
                    setElasticVerticalHeight(this);
                }
            }
        });

        const swiperImg = new Swiper(verticalSliderNode.querySelector('.v-slider-img'), {
            modules: [Navigation, Controller, A11y],
            direction: 'vertical',
            loop: false,
            speed: 1200,
            allowTouchMove: true,
            navigation: {
                nextEl: verticalSliderNode.querySelector('.btn-next'),
                prevEl: verticalSliderNode.querySelector('.btn-prev'),
            },
            on: {
                init: function () {
                    const total = String(this.slides.length).padStart(2, '0');
                    const label = verticalSliderNode.querySelector('.total-slides-label');
                    if (label) label.textContent = total;
                }
            }
        });

        swiperImg.controller.control = [swiperTitle, swiperNum, swiperTxt];
    }

    /**
     * Hero home
     */
    await loadModuleIfExists('.hero-home', () => import('./heroHome.js'))

    /**
     * Hero punto ristoro
     */
    await loadModuleIfExists('.hero-ristoro', () => import('./heroPuntoRistoro.js'))

    /**
     * Hero scheda location
     */
    await loadModuleIfExists('.hero-location', () => import('./heroSchedaLocation.js'))

    /**
     * Vertical slider
     */
    await loadModuleIfExists('.vertical-slider-v2', () => import('./verticalSliderV2.js'))

    /**
     * Intro animata (pagina servizi)
     */
    await loadModuleIfExists('.animated-intro', () => import('./animatedIntro.js'))
})